import { PatientOrderFormType } from '@app/icare/db/schema/form/PatientFormType'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const ArticlePriority = {
  high: 'high',
  medium: 'medium',
  low: 'low',
}

export const ArticleCategoryId = entityId('articleCategory')

export type ArticleCategoryIdType = typeof ArticleCategoryId.Type

export const ArticleCategorySchema = z.object({
  id: ArticleCategoryId.schema,
  name: z.string().min(1),
  mainCategoryName: z.string().min(1),
  forms: z
    .array(
      z.object({
        type: z.enum(PatientOrderFormType),
        priority: z.enum(ArticlePriority).default(ArticlePriority.medium),
      }),
    )
    .default([]),
})

export type ArticleCategory = z.infer<typeof ArticleCategorySchema>
